import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

export const Route = createFileRoute("/terms")({
  loader: async () => { await setEdgeHtmlCache({ sMaxAge: 1800 }); },
  head: () => buildHead({
    locale: "en",
    title: "Terms of Service: Shugert",
    description: "The terms governing use of shugert.com.mx and Shugert Agency's Shopify development, SEO, and CRO services, including fees, IP, and liability.",
    path: "/terms",
    altPath: alternatePath("/terms", "es"),
  }),
});
